module.exports = __webpack_public_path__ + "common/sidebar/icon-credit-card-c06d6dfe80d35707b32b71c0a213c6ff.svg";